<template>
  <div
    class="checkout-label"
    :style="{ backgroundColor: color }"
  >
    <f-sprite-icon
      v-if="icon"
      :icon-link="icon"
    />
    {{ title }}
  </div>
</template>

<script>
/* Icons */
import IconBox from '@icons/box.svg';
import IconPoint from '@icons/point.svg';

export default {
  name: "checkout-label",

  icons: {
    IconBox,
    IconPoint
  },

  props: {
    title: String,
    type: String
  },

  computed: {
    icon() {
      switch(this.type) {
        case 'delivery':
          return this.$options.icons['IconBox'].id;
        case 'pickup':
        case 'thirdparty':
          return this.$options.icons['IconPoint'].id;
        default:
          return '';
      }
    },

    color() {
      return this.type === 'unallocated' ? '#FFB71B' : '#95D4E9';
    }
  }
}
</script>

<style lang="scss">
  .checkout-label {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 24px;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    line-height: 16px;
    color: #fff;
    background-color: $blue_l;
    white-space: nowrap;

    svg {
      width: 16px;
      height: 16px;
      margin-right: 4px;
      color: $white;
    }
  }
</style>
